const BETA_HOSTNAME = 'wtt.airframemedia.co.uk';

/**
 * The beta origin runs Next.js development mode, where service workers are
 * disabled. Retire any production worker left behind on that origin: its
 * long-lived static cache can otherwise keep serving an old Turbopack chunk
 * even after a hard refresh.
 */
export function shouldRetireServiceWorker(hostname: string): boolean {
  return hostname.toLowerCase() === BETA_HOSTNAME;
}
